import vuex from "src/vuex"
import router from "src/http/router";
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";
import userPermission from "src/util/valueObjects/userPermission";



export default (to, from, next) => {
  let permissions = vuex.getters.getPermissions;
  let hasModule = false;
  for (let permission of permissions) {
    let module = userPermission.ALL_MODULES.FINANCE.value;
    if (permission.search(module+"__") !== -1) {
      hasModule = true;
    }
  }
  // console.log(this.$hasModule(userPermission.ALL_MODULES.INTEGRA_MANAGER.value))
  if(hasModule === false){
    vuex.dispatch("redirectToMainMenu");
  }
  // if(vuex.getters.getPermissions.indexOf(userPermission.ALL_MODULES.FINANCE.value) === -1){
  //   router.push({name: 'main.menu'});
  // }
  next();
};
